<template>
<div class="search-label-body" :class="{'label-hidden':labelHidden}">
  <div class="search-label-body-container">
    <span v-if="!labelHidden" >{{ label }}</span>
    <slot></slot>
  </div>
</div>
</template>

<script>
export default {
  name: "SearchLabelBody",
  props:{
    label: String,
    labelHidden : Boolean,
  }
}
</script>

<style lang="scss" scoped>
.search-label-body {
  & > .search-label-body-container {
    display: grid;
    grid-template-columns: auto auto;
    gap: 1rem;
  }
}

.search-label-body > .search-label-body-container > span {
  font-weight: 500;
  line-height: 38px;
  white-space: nowrap;
}

@media (max-width: 1200px) {
  .search-label-body {
    & > .search-label-body-container {
      grid-template-columns: 114px 1fr;
    }
  }
}

.search-label-body.label-hidden > .search-label-body-container {
  grid-template-columns: auto;
}
</style>
